

































import Vue from "vue";
import { state } from "./data/state";
export default Vue.extend({
  setup(_, { root: { $router } }) {
    const { current_overview } = state;
    const setup_source = () => {
      const { id, type } = current_overview.value;
      $router.push({
        name: "DataSourceManagement",
        query: { tab: type, source: id, action: "setup" },
      });
    };
    return {
      current_overview,
      setup_source,
    };
  },
});
